import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import PaymentSuccessful from 'assets/images/payment-successful.svg';
import { SuccessStateType, useLastPayment } from 'hooks';
import { GenericResult } from 'components';
import styled from 'styled-components';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { localStorageService } from '../../../utils/LocalStorageService';

const { Text } = Typography;

const StyledText = styled(Text)`
  margin-bottom: 1em;
  display: block;
`;

export const PaymentSuccess = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const { claimIds } = (state || {}) as SuccessStateType;
  const { lastPayment } = useLastPayment();

  const realPayment = claimIds && lastPayment?.claimId;
  const rightPayment = claimIds === lastPayment?.claimId;

  useEffect(() => {
    return () => {
      localStorageService.remove('LastPayment');
    };
  }, []);

  if (!(realPayment && rightPayment)) return <Navigate to={'/notFound'} />;

  return (
    <GenericResult
      icon={<img alt="PaymentSuccessfulIcon" src={PaymentSuccessful} />}
      title={t('claims.shortfall.paymentSuccessful')}
      subTitle={`${t('shortfallPayment.paymentReferenceNo')} ${lastPayment?.referenceNo}`}
      defaultTo="/home"
      content={<StyledText>{t('shortfallPayment.thankYou')}</StyledText>}
    />
  );
};
